module.exports = __webpack_public_path__ + "static/img/username.d4d9b11.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/username.png
// module id = W0/8
// module chunks = 2